import { ErrorContext } from "./ErrorContext"

export const useThrowError = () => {
  const context = React.useContext(ErrorContext)
  if (!context) {
    throw new Error("useThrowError must be used within an ErrorProvider")
  }
  return context.throwError
}
